import React from 'react';

const EmptyPage = () => (
  <div className="page page--narrow">
    <p className="empty-page">Coming soon. I promise I'm working on it.</p>
  </div>
);

export default EmptyPage;
